import { noOp } from 'common/Constants';
import React from 'react';
import { pickSubcuisineIcon } from 'src/pages/consumer/explore/components/cuisine-filters/pickSubcuisineIcon';
import { SegmentFilterIcon } from 'src/pages/consumer/explore/components/cuisine-filters/SegmentFilterIcon';
import { BaseCard } from './BaseCard';
import { RESULT_IMAGE_DIMENSIONS } from './consts';
import { useCuisineCard } from './hooks';
import { LoadingCuisineImage, LoadingSubTitle, LoadingTitle, TextChip } from './styles';
import { CuisineCardProps } from './types';

export const CuisineCard: React.FC<CuisineCardProps> = (props) => {
  const { cuisineResult, hideCounts } = props;
  const { hoverIcon } = pickSubcuisineIcon(cuisineResult.category);
  const cardProps = useCuisineCard(props);
  const allCardProps = hideCounts
    ? {
        ...cardProps,
        subtitle: '',
      }
    : {
        ...cardProps,
        rating: <TextChip text={`${cuisineResult.numShefs} shefs`} showInline />,
      };

  return (
    <BaseCard
      {...allCardProps}
      image={
        <SegmentFilterIcon
          colored
          segmentFilter={null}
          onClick={noOp}
          icon={hoverIcon}
          iconWidth={RESULT_IMAGE_DIMENSIONS}
          hoverIcon={hoverIcon}
        />
      }
    />
  );
};

export const LoadingCuisineCard = () => (
  <BaseCard image={<LoadingCuisineImage />} title={<LoadingTitle />} subtitle={<LoadingSubTitle />} />
);
